import { RedirectPaths, RedirectPathsEnum } from '@/common/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const EmptyBanner = styled.div`
  width: 100%;
  background-color: var(--white-main);
  border-radius: var(--xsmall-border-radius);
  border: 1px solid var(--gray-moderate);
  padding: var(--default-padding);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-top: var(--default-padding);
  cursor: pointer;

  .empty-title {
    font-size: var(--semi-big-font-size);
    line-height: var(--semi-big-line-height);
    font-weight: 700;
    color: var(--black-main);
    margin: 0 0 var(--xsmall-padding);
  }

  .empty-description {
    font-size: var(--small-font-size);
    line-height: var(--small-line-height);
    font-weight: 400;
    margin: 0;
    max-width: 620px;
  }
`;

export const EmptyCampaignBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <EmptyBanner
      onClick={() => navigate(RedirectPaths[RedirectPathsEnum.CAMPAIGNS]())}
    >
      <p className="empty-title">{t('dashboard.banner.noSimulations.title')}</p>
      <p className="empty-description">
        {t('dashboard.banner.noSimulations.description')}
      </p>
    </EmptyBanner>
  );
};
